import Vue from 'vue';
import Vuex from 'vuex';
import { genericStoreMutations } from '../vuefire'
// import createPersistedState from 'vuex-persistedstate'
// import { ENABLE_PERSISTENT_REGISTRY } from '@/features'

// TODO: Replace vuex store with vue instance - maybe
// TODO: See vuexfire how to pack mutations

Vue.use(Vuex)

const registry = new Vuex.Store({
  strict: true,
  plugins: /* ENABLE_PERSISTENT_REGISTRY ? [ createPersistedState() ] : */ [],
  state: {
    initialized: false,
    res: {},
    sync: {},
    ready: {}
    // index: {},
  },
  getters: {
    get_registry_entry: (state) => name => {
      return state.sync[ name ];
    },
    is_ready: (state) => name => {
      return state.ready[ name ] || false;
    },
  },
  mutations: {

    ...genericStoreMutations,

    INIT_REGISTRY(state) {
      state.initialized = true;
    },

    RESET_REGISTRY(state) {
      // Callend on logout
      Vue.set( state, 'sync',  {})
      Vue.set( state, 'res',   {})
      Vue.set( state, 'ready', {})
      state.initialized = false;
    },

    ADD_ENTRY(state, data) {
      Vue.set( state.sync, data.name, data )
    },

    // TODO: Kann das komplett enfallen?
    SET_ENTRY_STATUS( state, { name, value } ) {
      // state.sync[ name ].status = value;
      Vue.set(state.sync[ name ], 'status', value)
    },

    SET_GLOBAL_READY_STATE( state, { name, value } ) {
      // state.ready[ name ] = !!value;
      Vue.set(state.ready, name, !!value)
    },

    REM_GLOBAL_READY_STATE( state, { name } ) {
      Vue.delete(state.ready, name)
    }
  },
});

export default registry;
